export default "__VITE_ASSET__pODzA$xs__"